import { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartData,
  ChartOptions,
  BarElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { GetActiveUsersQuery } from '@/graphql/generated/graphql';
import { getColor } from '../../utils/colors';

ChartJS.register(LinearScale, PointElement, LineElement, ArcElement, CategoryScale, BarElement, Tooltip, Legend, Title);

export default function ActiveUserReportPage({ data }: { data?: GetActiveUsersQuery }) {
  const [lineData, setLineData] = useState<ChartData<'line'>>({ datasets: [] });

  useEffect(() => {
    const labels = [...new Set<string>(data?.getActiveUsers?.data?.map((user) => user!.date!))];
    const schoolsIds = [...new Set<string>(data?.getActiveUsers?.data?.map((e) => e!.schoolName!))];

    const datasets: { label: string; data: number[]; backgroundColor: string; borderColor: string; tension: number }[] =
      [];

    schoolsIds.forEach((schoolName, index) => {
      const color = getColor(index);
      const dataset = {
        label: schoolName,
        data: [] as number[],
        backgroundColor: color,
        borderColor: color,
        tension: 0.4,
      };

      dataset.data = labels.map((label) => {
        const item =
          data?.getActiveUsers?.data?.find((user) => user?.date === label && schoolName === user.schoolName)
            ?.countUniqueUsers || 0;
        return item;
      });

      datasets.push(dataset);
    });

    setLineData({
      labels,
      datasets,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const options: ChartOptions<'line'> = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const schoolName = tooltipItem.dataset.label;
            const users = tooltipItem.raw as number;
            return `${schoolName}: ${users} users`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Date',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Users',
        },
      },
    },
  };

  return (
    <>
      <div className="col-span-12 mb-6 h-full">
        <Line data={lineData} options={options} style={{ width: 'auto' }} />
      </div>
    </>
  );
}
